import { useApi } from "helpers/useApi";
export const usePassPageSrv = () => {
    const { api } = useApi();
    const httpgetPassList = () => {
        return api.get('/api/memberpass')

    }
    const httpgeneratePass = (data: any) => {
        return api.post('/api/memberpass', data)
    }
    return { httpgetPassList, httpgeneratePass }
}